$(document).ready(function(){
  

    $('.accessibly-otm-widget-link').click(function(event){
      event.preventDefault();

      //$('#accessiblyAppDialog').css('display', 'block');
      //$('#accessiblyAppDialog .accessibly-app-widget').toggleClass('accessiblyAppDialog');
      //$('#accessiblyAppDialog).siblings(".accessibly-app-widget").toggle();

      var toggled=$("#accessiblyAppDialog");
      var linkIndex = "div.accessibly-app-widget";
      
    
      // do this: create your own toggle if clause.
      if(toggled.attr("tabindex") == -1) {
        
        $ (linkIndex).attr("hidden",true);
        $ (linkIndex).attr("tabindex", 0);
      }else{
        $ (linkIndex).removeAttr('hidden');
        $ (linkIndex).attr("tabindex", -1);
      }
  });
 
 

});